import { gql } from '@apollo/client';

export const PEAK_CONFIG_FRAGMENT = gql`
  fragment PeakConfigFields on OattPeakConfig {
    oatt_peak_config_id
    on_peak_day_start
    on_peak_day_end
    off_peak_day_start
    off_peak_day_end
    on_peak_start
    on_peak_end
    off_peak_start
    off_peak_end
  }
`;

export const GET_OATT_PEAK_CONFIG = gql`
  ${PEAK_CONFIG_FRAGMENT}
  query GetOattPeakConfig {
    getOattPeakConfig {
      ...PeakConfigFields
    }
  }
`;

export const UPSERT_OATT_PEAK_CONFIG = gql`
  ${PEAK_CONFIG_FRAGMENT}
  mutation UpsertOattPeakConfig($input: OattPeakConfigInput!) {
    upsertOattPeakConfig(input: $input) {
      ...PeakConfigFields
    }
  }
`;
